module.exports = __webpack_public_path__ + "static/media/swipingGirl.04a514a8.gif";